module.exports = __webpack_public_path__ + "images/rich_heading/small_appliance/portable_music_player/icon_f0df9742dfd183d619c37e96af40bbd4.png";